<template id="switch-button">
  <div>
    <div v-if='!trackProgress' class="note">
      {{ $t('checklist.note_checklist') }}
    </div>

    <div class="switch-visibility">
      <div class="switch-button-control">
        <p class="switch-button-label">
          {{ $t('checklist.include_folder_to_checklist') }}
        </p>
        <div class="switch-button" :class="{ enabled: trackProgress }" @click="updateFolderTrackProgress" :style="{ 'color': color }">
          <div class="button"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      folder: {
        type: Object,
        required: true,
      },
      color: {
        type: String,
        required: false,
        default: "#C4C4C4"
      }
    },
    computed: {
      trackProgress() {
        return this.folder.track_progress
      },
    },
    methods: {
      updateFolderTrackProgress() {
        this.store.updateFolder(this.folder.id, { track_progress: !this.trackProgress }).then(() => {
          this.$emit('success')
          this.store.sendMetrics({name: 'update_folder_track_progress', params: this.$route.params, path: this.$route.fullPath})
        })
      },
    }
  }
</script>

<style scoped lang="sass">
  .switch-button-control
    display: flex
    align-items: center
    width: fit-content
    .switch-button-label
      margin: 0
  .switch-button-control .switch-button
    height: 1.6em
    width: calc(1.6em * 2)
    border: 2px solid #C4C4C4
    box-shadow: inset 0 0 2px 0 rgba(0, 0, 0, 0.33)
    border-radius: 1.6em
    transition: all 0.3s ease-in-out
    cursor: pointer
    margin: 10px 0 10px 10px
  .switch-button-control .switch-button .button
    height: calc( 1.6em - (2 * 2px) )
    width: calc( 1.6em - (2 * 2px) )
    border: 2px solid #C4C4C4
    border-radius: calc( 1.6em - (2 * 2px) )
    background: #C4C4C4
    transition: all 0.3s ease-in-out
  .switch-button-control .switch-button.enabled
    background-color: #44C15F
    box-shadow: none
    border: 2px solid #44C15F
  .switch-button-control .switch-button.enabled .button
    background: white
    transform: translateX(calc(calc( 1.6em - (2 * 2px) ) + (2 *2px)))
    border: 2px solid #fff
</style>
